<template>
    <div class="member_ios" v-if="showIf">
        <top :Info="Info"></top>
        <meal 
            :Info="Info" 
            source="ios" 
            v-if="!Info.needUpgrade"
            @toggleMemberProductPopup="toggleMemberProductPopup"
            ref="meal"
        ></meal>
        <meal-update 
            :Info="Info" 
            source="ios" 
            v-if="Info.needUpgrade"
            ref="mealUpdate"
        ></meal-update>
        <div class="statement">
            <div class="tit">自动续费声明</div>
            <div class="item">
                1.付款：“连续包月/季/年”会员为自动续费类商品，确认购买后，会从您的苹果iTunes账号中扣款；
            </div>
            <div class="item">
                2.续费：在您订阅周期到期前24小时内，苹果会自动从iTunes账户中扣款，扣款成功将自动延长会员有效期；
            </div>
            <div class="item">
                3.取消续订:如果需要取消续订,请在当前订阅周期到期前24小时之前,手动在 iTunes/Apple ID设置管理中关闭。
            </div>
            
        </div>
        <agreement source="ios"></agreement>
        <quan-yi source="ios"></quan-yi>
        <no-pay-pop-up 
            :needUpgrade='Info.needUpgrade'
            v-if="showFailToast"
            @close="closePop"
            @pay="goPay"
        ></no-pay-pop-up>
        <same-member-product-popup 
            v-if="showSameProductPopup"
            @toggleMemberProductPopup="toggleMemberProductPopup">
        </same-member-product-popup>
    </div>
</template>

<script>
import ajax from "@/api/memberAjax.js";
import utils from "@/assets/js/utils";
import NoPayPopUp from "./no_pay_popup";
import Top from "./member_top";
import Meal from "./member_meal";
import MealUpdate from "./member_update_meal";
import QuanYi from "./member_quanyi";
import Agreement from "./member_agreement";
import SameMemberProductPopup from "./same_member_product_popup";
const token = utils.getQueryString('token');
const version = utils.getQueryString('version');
const source = utils.getQueryString('source');
const categoryId = utils.getQueryString('categoryId');
const pageChannelId = utils.getQueryString('pageChannelId');
const productId = utils.getQueryString('productId');    //商品Id

var vm = null;
window.failToast = function(res) {
    if(res == 'cancel') {
        vm.showFailToast = true;
    }   
}

window.jsCallback = function(res) {
    if(res == 'cancel') {
        vm.showFailToast = true;
    }else {
        if(window.goAddress) window.location.href = '/#/address?version=' + version + '&token=' + token + '&source=' + source
        else window.location.href = 'hybird://method/exit';
    }
}

export default {
    name: "",
    components: {
        NoPayPopUp,
        Top,
        Meal,
        MealUpdate,
        QuanYi,
        Agreement,
        SameMemberProductPopup
    },
    data() {
        return {
            showFailToast: false,       // 支付取消、失败弹框
            showSameProductPopup: false,    // 已购买套餐弹窗
            showIf: false,
            Info: {
                memberInfo: {
                    isMember: 0, // 是否是会员 1是 0否
                    username: "小白兔白又白🐰",
                    memberDesc: "开通会员 全场免费学",// 会员信息描述
                },
                needUpgrade: 1,// 是否升级,1是 0否,如果是1时
                superMember: 12,// 超级会员时间,单位天
                syncTest: 124,// 同步练会员时间,单位天
                // freeDays: 123,// 升级时免费天数
                memberProductList:[ // needUpgrade=1时此字段只有升级对应产品
                    {
                        "productId": 993,// 产品id
                        "title": "连续包月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":1,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                        "productType": 23,  // 会员连续包月
                    },
                    {
                        "productId": 994,// 产品id
                        "title": "连续包月优惠",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":1,// 是否有价格比对
                        "productType": 24,  // 会员连续包月优惠
                    },
                    {
                        "productId": 995,// 产品id
                        "title": "连续包季",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                        "productType": 25,  // 会员连续包季
                    },
                    {
                        "productId": 996,// 产品id
                        "title": "连续包年",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                        "productType": 26,  // 会员连续包年
                    },
                    {
                        "productId": 997,// 产品id
                        "title": "1个月",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                        "productType": 27,  // 会员1个月
                    },
                    {
                        "productId": 998,// 产品id
                        "title": "1个季度",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                        "productType": 28,  // 会员1个季度
                    },
                    {
                        "productId": 999,// 产品id
                        "title": "1年",// 标题
                        "originPrice": 158,// 原价
                        "discountPrice": 158,// 优惠价
                        "isPromotion":0,// 是否有首次开通标识,1是 0否
                        "isRecommend":0,// 是否是推荐,1是 0否
                        "hasPriceCompare":0,// 是否有价格比对
                        "productType": 29,  // 会员1年
                    }
                ]
            }
        }
    },
    methods: {
        async getInfo() {
            const [resp] = await ajax.all([
                ajax.get('/pay/common/member-sale-page', {
                    params: {
                        token,
                        version,
                        source
                    }   
                })
            ])
            if(resp.data.code == 99999){
                console.log(resp.data);
                let data = resp.data.data;
                this.Info = data;
                this.showIf = true;
                if(this.Info.needUpgrade){
                    gio('track', 'vipUpdatePage_show', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx912')
                }else{
                    gio('track', 'vipOpenPgae_show', this.getGioParams());
                    utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: this.getGioParams()
                    }, 'hzxx910')
                }
            }

        },
        closePop() {
            this.showFailToast = false;
        },
        goPay() {
            this.Info.needUpgrade ? this.$refs.mealUpdate.goPay('cancelPop') : this.$refs.meal.goPay('cancelPop');    
        },
        getGioParams(){
            return {
                categoryId,
                pageChannelId,
                isVip: this.Info.memberInfo.isMember,
                productId,
            }
        },
        toggleMemberProductPopup(){
            this.showSameProductPopup = !this.showSameProductPopup;
        }
    },
    created() {
        this.getInfo();

        vm = this;

    }
}
</script>

<style lang="scss" scoped>
.member_ios {
    text-align: center;
    font-family: PingFangSC-Medium;
    .statement {
        background: #ffffff;
        padding: .4rem .4rem 0 .4rem;
        text-align: left;
        .tit {
	        height: .6rem;
            line-height: .56rem;
	        font-family: PingFangSC-Medium;
	        font-size: .28rem;
	        color: #5f6162;
        }
        .item {
            font-size: .22rem;
            color: #919294;
        }
        
    }
    .quanyi {

    }

}
</style>